/* eslint-disable no-param-reassign */
import createSlice, { PayloadAction } from '@lumapps/redux/createSlice';

import { SpaceData } from '../types';

export const domain = 'space';

export interface SpaceState {
    isNavigationAdminDialogOpen: boolean;
    data: SpaceData | null;
    id: string | null;
}

export const initialState: SpaceState = {
    isNavigationAdminDialogOpen: false,
    data: null,
    id: null,
};

export const { actions, reducer } = createSlice({
    domain,
    initialState,
    reducers: {
        reset: () => initialState,
        success: (state: SpaceState, action: PayloadAction<{ data: SpaceData; id: string }>) => {
            state.data = action.payload.data;
            state.id = action.payload.id;
        },
        openNavigationAdminDialog: (state: SpaceState) => {
            state.isNavigationAdminDialogOpen = true;
        },
        closeNavigationAdminDialog: (state: SpaceState) => {
            state.isNavigationAdminDialogOpen = false;
        },
    },
});
